import { Badge, Card, Col, Row } from 'react-bootstrap';
import { FaPeopleArrows } from 'react-icons/fa';
import CommonSearchField from '../../../../Components/Common/CommonSearchField';
import { useGetB2BAvailableSlotList } from '../../apiEndpoints/b2bBuyerSellerEndpoint';
import { Link } from 'react-router-dom';
import { imgUrl } from '../../../../Helpers/Constant';
import './MeetingBooking.css';
import SlotsCompanyFilter, { IAvailableFilter } from './SlotsCompanyFilter';
import { useState } from 'react';
import CommSelectField from '../../../../Components/Common/CommSelectField';
const MeetingBooking = ({
  type,
  user_id,
}: {
  type: 'B2B' | 'Exhibitor';
  user_id: number;
}) => {
  const [filter_type, setFilterType] = useState<IAvailableFilter | any>();
  const [selectedValue, setSelectedValue] = useState('');
  const [keywords, setKeyWords] = useState('');

  const selectedFilters =
    filter_type &&
    Object?.keys(filter_type)
      ?.filter((key) => filter_type[key])
      .map((filter: any) => `filter_type=${filter_type[filter]}`)
      .join('&');
  const finalQuery = selectedFilters ? `/?${selectedFilters}` : '';
  const { data } = useGetB2BAvailableSlotList({
    type: type,
    user_id: user_id as number,
    filter_type: finalQuery,
    business_type: selectedValue,
    keywords: keywords,
  });
  const options = [
    { label: 'Tour Operator', value: 'Tour Operator' },
    { label: 'Destination Company', value: 'Destination Company' },
    { label: 'Hotel', value: 'Hotel' },
    { label: 'Airline', value: 'Airline' },
  ];
  const handleChange = (event: any) => {
    setSelectedValue(event);
  };

  return (
    <Card style={{ border: 'none', padding: '15px 10px' }}>
      <h2 className='text-center mb-2'>
        <FaPeopleArrows className='me-2' />
        Book Your Meeting
      </h2>

      <Row className='mb-3 align-items-center'>
        <Col lg={4}>
          <SlotsCompanyFilter onChange={(value) => setFilterType(value)} />
        </Col>
        <Col lg={4}>
          <CommSelectField
            clearIcon
            fieldName='b2b_id_type'
            isRequired
            label='Passport/NID'
            options={
              options.map((item) => ({
                label: item.label,
                value: item.value,
              })) || []
            }
            placeholder='Select business type'
            onChange={handleChange}
          />
        </Col>
        <Col lg={4}>
          <CommonSearchField
            placeholder='Search by keywords...'
            onChange={(e) => setKeyWords(e)}
          />
        </Col>
      </Row>

      <Row xs={1} md={2} lg={3} xl={3} xxl={4} className='g-4'>
        {data?.data?.length ? (
          data?.data?.map((person) => (
            <Col key={person.id} className='mb-3'>
              <Link
                to={
                  type === 'B2B'
                    ? person?.type === 'B2B'
                      ? `/b2b/available-slot/${person.user_id}?type=${person.type}`
                      : `/b2b/available-slot/${person.user_id}?type=${person.type}&staff_id=${person.staff_id}`
                    : `/profile/available-slot/${person.user_id}?type=${person.type}`
                }
                className='text-decoration-none'
              >
                <Card className='person-card h-100 shadow-sm border-0'>
                  {/* Full-width image */}
                  <div className=''>
                    <Card.Img
                      variant='top'
                      src={`${imgUrl}/${person?.company_logo}`}
                      className='w-100 p-3'
                      style={{
                        height: '300px',
                        objectFit: 'cover',
                        borderTopLeftRadius: '8px',
                        borderTopRightRadius: '8px',
                      }}
                    />
                  </div>

                  {/* Information section */}
                  <Card.Body className='p-3'>
                    <div className='person-info'>
                      {/* Type */}
                      <div className='d-flex mb-2'>
                        <span
                          className='text-muted me-2'
                          style={{ width: '90px' }}
                        >
                          Type:
                        </span>
                        <Badge
                          bg={person.type === 'Exhibitor' ? 'warning' : 'info'}
                          className='text-capitalize'
                        >
                          {person.type}{' '}
                          {person.type !== 'Exhibitor' &&
                            `(${
                              person.b2b_type === 'Both'
                                ? 'Buyer/Seller'
                                : person.b2b_type
                            })`}
                        </Badge>
                      </div>
                      {/* Name */}
                      <div className='d-flex mb-2'>
                        <span
                          className='text-muted me-2'
                          style={{ width: '90px' }}
                        >
                          Name:
                        </span>
                        <span className='fw-semibold'>
                          {person.name || 'N/A'}
                        </span>
                      </div>

                      {/* Designation */}

                      <div className='d-flex mb-2'>
                        <span
                          className='text-muted me-2'
                          style={{ width: '90px' }}
                        >
                          Designation:
                        </span>
                        <span>{person.designation || 'N/A'}</span>
                      </div>

                      {/* Company */}
                      <div className='d-flex mb-2'>
                        <span
                          className='text-muted me-2'
                          style={{ width: '90px' }}
                        >
                          Company:
                        </span>
                        <span className='fw-semibold text-primary'>
                          {person.company_name || 'N/A'}
                        </span>
                      </div>
                      <div className='d-flex mb-2'>
                        <span
                          className='text-muted me-2'
                          style={{ width: '90px' }}
                        >
                          About us:
                        </span>
                        <span className='fw-semibold text-primary'>
                          {person.company_brief || 'N/A'}
                        </span>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Link>
            </Col>
          ))
        ) : (
          <p className='text-center w-100'>No Data found.</p>
        )}
      </Row>
    </Card>
  );
};

export default MeetingBooking;
